import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { ButtonClickCard, Drawer, SearchEmpty } from "components";

import { usePermissions } from "hooks/permission";
import { useToast } from "hooks/toast";

import { hideLoading, showLoading } from "store/modules/loading/actions";

import { storageKentaService } from "services/StorageKenta";

import { LogOperation } from "utils/entities/logOperation";
import { FORMS_HEARING } from "utils/entities/permission";

import { LoadSpinner } from "../../LoadSpinner";

interface Props {
  isOpenDownloadsModal: boolean;
  setIsOpenDownloadsModal: (isOpen: boolean) => void;
}

export function DownloadAppModal({
  isOpenDownloadsModal,
  setIsOpenDownloadsModal,
}: Props) {
  const { t } = useTranslation();
  const [listOfDownloads, setListOfDownloads] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const { addToast } = useToast();

  const { export: exportFiles } = usePermissions(FORMS_HEARING.HEARING_FILE);

  async function findFiles() {
    if (exportFiles) {
      dispatch(showLoading());
      try {
        const { success, body } = await storageKentaService.GetAllBlobs();

        if (success && body?.length > 0) {
          setListOfDownloads(body);
        }
      } catch {
        addToast({
          type: "error",
          title: t("downloads.fetchError"),
          description: t("connection.checkAndRetry"),
        });
      } finally {
        dispatch(hideLoading());
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (isOpenDownloadsModal) findFiles();
  }, [isOpenDownloadsModal]);

  const tamanho = (bytes: number) => {
    const total = (bytes / 1024).toFixed(2);
    if (Number(total) > 1000) {
      return (bytes / 1048576).toFixed(2) + " MB ";
    }
    return total + " KB";
  };

  const clicouEmBaixar = () => {
    LogOperation.postLogOperation("HearingFile", 6, 0);
  };

  return (
    <>
      {loading ? (
        <LoadSpinner loading={loading} />
      ) : (
        <Drawer
          open={isOpenDownloadsModal}
          onClose={() => setIsOpenDownloadsModal(!isOpenDownloadsModal)}
          title={t("downloads.appsAndDocs")}
          footer="none"
          paddingLeft={28}
          paddingRight={32}
        >
          {exportFiles ? (
            listOfDownloads && listOfDownloads.length > 0 ? (
              listOfDownloads.map((item: any) => {
                return (
                  <ButtonClickCard
                    key={item?.name}
                    title={item?.name}
                    subTitle={tamanho(item.filesize)}
                    typeButton={"download"}
                    typeIcon={"file"}
                    onClick={() => {
                      clicouEmBaixar();
                      window.open(item.url);
                    }}
                  />
                );
              })
            ) : (
              <SearchEmpty
                typeIcon="file"
                textMessage={t("downloads.emptyMessage")}
              />
            )
          ) : (
            <SearchEmpty
              typeIcon="file"
              textMessage={t("common.noPermissionForProfile")}
            />
          )}
        </Drawer>
      )}
    </>
  );
}
